import { PermissionPathList } from 'src/hooks/usePermission'

/**
 * Every slug of an area opens its page: the list itself needs the `index`
 * slug (the page shows a hint instead of it), the other slugs gate the
 * actions on that page.
 */
export const MARKETING_PERMISSIONS: PermissionPathList = [
  'marketing.campaigns.index',
  'marketing.campaigns.store',
  'marketing.campaigns.update',
  'marketing.campaigns.destroy',
  'marketing.campaigns.send',
]

export const TEMPLATES_PERMISSIONS: PermissionPathList = [
  'templates.index',
  'templates.store',
  'templates.update',
  'templates.destroy',
]

export const FORMS_PERMISSIONS: PermissionPathList = [
  'forms.index',
  'forms.store',
  'forms.update',
  'forms.destroy',
  'forms.submits.index',
]

export const API_KEYS_PERMISSIONS: PermissionPathList = [
  'auth.apiKeys.index',
  'auth.apiKeys.store',
  'auth.apiKeys.destroy',
]

export const NUMBERS_PERMISSIONS: PermissionPathList = [
  'communication.numbers.index',
  'communication.numbers.store',
  'communication.numbers.update',
  'communication.numbers.destroy',
  'communication.numbers.manage',
]

// The settings menu: the numbers page lives there, so any number slug needs it
export const SETTINGS_PERMISSIONS: PermissionPathList = [
  'auth.partner.update',
  'auth.partner.billingStat',
  'auth.users',
  'storage.objectScheme',
  'auth.groups',
  'integrations.index',
  ...API_KEYS_PERMISSIONS,
  ...NUMBERS_PERMISSIONS,
]
